import { Component, Input, OnInit, Renderer2 } from '@angular/core';

// services
import { TrustpilotService, ScriptLoaderService } from '@campfire-nx/api';

@Component({
  selector: 'open-social-rating',
  templateUrl: './open-social-rating.component.html',
  styleUrls: ['./open-social-rating.component.scss']
})
export class OpenSocialRatingComponent implements OnInit {
  @Input() componentDetails: any;
  ratingId = `dynamic-rating-id-${Math.floor(Date.now() * Math.random())}`;

  constructor(
    private renderer: Renderer2,
    private trustpilotService: TrustpilotService,
    private scriptLoaderService: ScriptLoaderService
  ) {}
  
  ngOnInit(): void { 
    this.setComponentDefaults();

    if (this?.componentDetails?.enabled) {
      
      if (this.componentDetails?.provider === 'productreview') {
        this.productReview();
      }

      if (this.componentDetails?.provider === 'trustpilot') {
        this.trustpilotService.init([this.ratingId], {
          trustboxTemplate: this.componentDetails?.trustpilot?.trustboxTemplate,
          businessunitId: this.componentDetails?.trustpilot?.businessunitId
        }); 
      }
    }
  }

  setComponentDefaults() {
    if (this.componentDetails && !this.componentDetails?.theme) {
      this.componentDetails.theme = 'dark';
    }

    if (this.componentDetails && !this.componentDetails?.height) {
      this.componentDetails.height = '40px';
    }

    if (this.componentDetails && !this.componentDetails?.iconSize) {
      this.componentDetails.iconSize = 'large';
    }
  }

  productReview() {
    const productReviewScript = document.getElementById('productreview');
    if (!productReviewScript) {
      this.scriptLoaderService.loadJsScript(
        this.renderer,
        null,
        'text/javascript',
        'https://cdn.productreview.com.au/assets/widgets/loader.js',
        'productreview'
      );
    
      // eslint-disable-next-line no-underscore-dangle
      (window as any).__productReviewSettings = {
        brandId: this?.componentDetails?.productreview?.brandId
      };
    }
    // eslint-disable-next-line no-underscore-dangle
    (window as any).__productReviewCallbackQueue = (window as any).__productReviewCallbackQueue || [];
    // eslint-disable-next-line no-underscore-dangle
    (window as any).__productReviewCallbackQueue.push((ProductReview: any) => {
      ProductReview.use('rich-rating-badge', {
        'container': `#${this.ratingId}`,
        'identificationDetails': {
          'type': 'single',
          'strategy': 'from-internal-entry-id',
          'identifier': this?.componentDetails?.productreview?.identifier
        }
      });
    });
  }
}